import React from "react";

import { NucleusExplainCell } from "../../components/nucleus_explain/NucleusExplainOverlay";
import type { NucleusExplainActivationHandler } from "../../entities/nucleus_explain_action";

type SupplyWalkExplainableValueProps = Readonly<{
  canExplain: boolean;
  disabled?: boolean;
  displayValue: string;
  identityKey: string;
  onExplain: NucleusExplainActivationHandler;
  periodLabel: string;
}>;

export const buildSupplyWalkExplainCellIdentity = ({
  scopeIdentity,
  measure,
  measureRank,
  periodStartEpochMs,
}: Readonly<{
  scopeIdentity: string;
  measure: string;
  measureRank: number | undefined;
  periodStartEpochMs: number;
}>): string =>
  JSON.stringify([
    scopeIdentity,
    measure,
    measureRank ?? "no-rank",
    periodStartEpochMs,
  ]);

/**
 * Keeps the saved Supply Walk value native while the shared hover overlay
 * owns the only interactive explanation action.
 */
export const SupplyWalkExplainableValue: React.FC<
  SupplyWalkExplainableValueProps
> = ({
  canExplain,
  disabled = false,
  displayValue,
  identityKey,
  onExplain,
  periodLabel,
}) => {
  if (!canExplain) {
    return <span>{displayValue}</span>;
  }

  return (
    <NucleusExplainCell
      ariaLabel={`Explain the saved ending-inventory balance for ${periodLabel} with Nucleus`}
      detailMode="trace"
      displayValue={displayValue}
      identityKey={identityKey}
      disabled={disabled}
      onExplain={onExplain}
    >
      {displayValue}
    </NucleusExplainCell>
  );
};
